import { render } from "./Container.vue?vue&type=template&id=1353b088"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
script.render = render

export default script